import React, { useState } from "react"
import "./header.css"
import { Link } from "react-router-dom"
import { useLanguage } from "../../../context/LanguageContext"
import { languageOptions } from "../../../data/siteContent"

const Header = () => {
  const [navList, setNavList] = useState(false)
  const { content, language, setLanguage } = useLanguage()
  const { header, nav, assets } = content

  return (
    <>
      <header>
        <div className='container flex'>
          <div className='logo'>
            <Link to='/' onClick={() => setNavList(false)}>
              <img src={assets.logo} alt={header.logoAlt} />
            </Link>
          </div>
          <div className='nav'>
            <ul className={navList ? "small" : "flex"}>
              {nav.map((list, index) => (
                <li key={index}>
                  <Link to={list.path} onClick={() => setNavList(false)}>
                    {list.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className='header-actions'>
            <div className='language-switcher' aria-label={header.languageLabel}>
              <span className='language-label'>{header.languageLabel}</span>
              {languageOptions.map((option) => (
                <button
                  type='button'
                  key={option.code}
                  className={language === option.code ? "active" : ""}
                  onClick={() => setLanguage(option.code)}
                >
                  {option.label}
                </button>
              ))}
            </div>
            <div className='button flex'>
              <h4>
                <span>{header.savedCount}</span> {header.savedLabel}
              </h4>
              <button type='button' className='btn1'>
                <i className='fa fa-sign-out'></i> {header.signIn}
              </button>
            </div>
          </div>

          <div className='toggle'>
            <button type='button' aria-label={header.mobileMenuLabel} onClick={() => setNavList(!navList)}>
              {navList ? <i className='fa fa-times'></i> : <i className='fa fa-bars'></i>}
            </button>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
